export default __webpack_public_path__ + "static/media/tus.3680db71.png";